import React, { Component } from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import CloseIcon from '@material-ui/icons/Close';
import Draggable from 'react-draggable';
import LockIcon from '@material-ui/icons/Lock';
import UnLockIcon from '@material-ui/icons/LockOpen';
import { circleBGColor } from '../../../util';

const closeIconStyle = {
  position: 'absolute',
  top: '-26px',
  right: '-19px',
  cursor: 'pointer',
};

const lockIconStyle = {
  position: 'absolute',
  top: '-26px',
  right: '3px',
  cursor: 'pointer',
};


const Circle = styled.div`
height:14px;
width: 14px;
border-radius:25px;
border-radius: 25px;
background-color: white;
border: 1px solid black;
position:absolute;
visibility:hidden;
z-index:1;
${(props) => props.styleData};
${(props) => `background-color:${props.backgroundColor}`}

`;

const StyledSquare = styled.div`
    position: absolute;
    background-color: ${(props) => props.styleObject.color};
    text-align: center;
    vertical-align: middle;
box-shadow:0 4px 4px rgba(0, 0, 0, 0.3), 0 4px 12px rgba(0, 0, 0, 0.22);
&:hover ${Circle} {
visibility:${(props) => (props.showClose ? 'visible' : 'hidden')};
}
`;

const StyledTextWrapper = styled.div`
position: relative;
word-break: break-word;
font-size: 14px;
padding: 6px;
overflow: auto;
width:60px;
height: 60px;
scrollbar-width: none;
          -ms-overflow-style: none;

          &::-webkit-scrollbar {
            width: 0;
            background: transparent;
          }
&:focus {
  outline:none;
}
&:hover{
  cursor:${(props) => (props.contentEditable ? 'text' : 'pointer')};
}
&:active{
  cursor: ${(props) => (props.showResize ? 'text' : 'grabbing')};
  cursor:${(props) => (props.showClose ? '' : 'pointer')};

}
`;
const StyledResize = styled.div` background-color: #727272;
width: 10px;
height: 10px;
cursor: se-resize;
position:absolute;
right: 0;
bottom: 0;
display:${(props) => (props.resize ? '' : 'none')};
`;

const CIRCLE_POSITIONS = [
  { top: '-2%', left: '-2%', position: 'topLeft' },
  {
    top: '50%', left: '-2%', transform: 'translateY(-50%)', position: 'left',
  },
  { bottom: '-2%', left: '-2%', position: 'bottomLeft' },
  { bottom: '-2%', left: '50%', position: 'bottom' },
  { right: '-2%', bottom: '-2%', position: 'bottomRight' },
  {
    top: '50%', right: '-2%', transform: 'translateY(-50%)', position: 'right',
  },
  { top: '-2%', right: '-2%', position: 'topRight' },
  { left: '50%', top: '-2%', position: 'top' },
];


export class Square extends Component {
  state = { lock: false };

  componentDidMount() {
    const { id } = this.props;
    const ele = document.getElementById(`${id}Resize`);
    ele.addEventListener('mousedown', this.initializeResize, false);
  }

  initializeResize = () => {
    window.addEventListener('mousemove', this.startResizing, false);
    window.addEventListener('mouseup', this.stopResizing, false);
  }

  stopResizing = () => {
    window.removeEventListener('mousemove', this.startResizing, false);
    window.removeEventListener('mouseup', this.stopResizing, false);
  }

  startResizing = (e) => {
    const { id, connectionUpdater } = this.props;
    const ele = document.getElementById(`${id}Text`);
    const { left } = ele.getBoundingClientRect();
    const { width: oldWidth } = window.getComputedStyle(ele);
    const width = e.clientX ? (e.clientX - left) : parseInt(oldWidth, 10);
    if (e.clientX) {
      ele.style.width = `${width}px`;
    }
    ele.style.height = `${width}px`;
    connectionUpdater();
  }

  toggleLock = () => {
    this.setState((state) => {
      const { lock } = state;
      return {
        lock: !lock,
      };
    });
  }


  autoResize = () => {
    const { id, connectionUpdater } = this.props;
    const ele = document.getElementById(`${id}Text`);
    const hasVerticalScrollbar = ele.scrollHeight > ele.clientHeight;
    if (hasVerticalScrollbar) {
      ele.style.height = `${ele.scrollHeight}px`;
      ele.style.width = `${ele.scrollHeight}px`;
    }
    connectionUpdater();
  }

  render() {
    const {
      styleObject, id, text, showClose,
      removeShape, activeCircleIndex, circleOnClick,
      connectFrom, connectHandler, connectionUpdater, currentActiveCircle,
    } = this.props;
    const { lock } = this.state;
    const Lock = lock ? LockIcon : UnLockIcon;
    return (
      <Draggable
        onDrag={connectionUpdater}
        disabled={!showClose || lock}
        enableUserSelectHack={false}
      >

        <StyledSquare
          styleObject={styleObject}
          id={id}
          lock={lock}
          showClose={showClose}

        >
          {showClose && (
            <CloseIcon style={closeIconStyle} onClick={removeShape} />

          )}
          {showClose && (
            <Lock style={lockIconStyle} onClick={this.toggleLock} />
          )}
          {showClose && CIRCLE_POSITIONS.map((obj, index) => {
            const circleId = `${id}circle${index}`;
            const backgroundColor = circleBGColor(connectFrom, circleId, activeCircleIndex, index, currentActiveCircle);
            return (
              <Circle
                key={circleId}
                styleData={obj}
                backgroundColor={backgroundColor}
                id={circleId}
                onClick={() => { circleOnClick(index, obj.position); }}
                onDoubleClick={() => { connectHandler(circleId, obj.position); }}
                lock={lock}
              />
            );
          })}

          <StyledTextWrapper
            contentEditable={showClose}
            showResize={lock}
            showClose={showClose}
            id={`${id}Text`}
            onKeyDown={this.autoResize}
          >
            {text}
          </StyledTextWrapper>
          <StyledResize id={`${id}Resize`} resize={lock} />
        </StyledSquare>
      </Draggable>
    );
  }
}


Square.propTypes = {
  styleObject: PropTypes.instanceOf(Object).isRequired,
  id: PropTypes.string.isRequired,
  text: PropTypes.node,
  showClose: PropTypes.bool,
  removeShape: PropTypes.func,
  circleOnClick: PropTypes.func,
  connectionUpdater: PropTypes.func,
  activeCircleIndex: PropTypes.number,
  connectHandler: PropTypes.func,
  connectFrom: PropTypes.string,
  currentActiveCircle: PropTypes.string,


};
Square.defaultProps = {
  text: '',
  showClose: true,
  removeShape: () => { },
  activeCircleIndex: 0,
  circleOnClick: () => { },
  connectionUpdater: () => { },
  connectHandler: () => { },
  connectFrom: '',
  currentActiveCircle: '',
};
